<script>
export default {
    methods: {
        getOptimalImageSize(type, width, height, maxWidth = 1170) {
            var string = "?"
            var pixelDensity = Math.min(window.devicePixelRatio, 2);
            if (type == "crop" || type == "resize")
                string += type
            else
                string += "resize"
            string += "&w="
            if (width == "fullwidth") {
                var optimalWidth = maxWidth;
                if (window.innerWidth < optimalWidth)
                    optimalWidth = optimalWidth - 70 * Math.floor((optimalWidth - window.innerWidth)/70);
                string += Math.floor(optimalWidth * pixelDensity)
            } else if (Number.isInteger(width)) {
                string += Math.floor(width * pixelDensity)
            } else {
                string += "-"
            }
            string += "&h="
            if (Number.isInteger(height)) {
                string += Math.floor(height * pixelDensity)
            } else {
                string += "-"
            }
            return string
        },
        getStandartMeta(name) {
            var title = this.$t('$meta.' + name + '.title');
            return {
                title: title,
                meta: [
                    { property: "og:title", content: title },
                    { property: "og:url", content: this.$router.fullPath },
                    { name: "twitter:title", content: title }
                ]
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// Page.vue?a5fa99e8